import { cn } from '@/lib/shadcn-utils';

export function ArkyvWordmark({ className }: { className?: string }) {
  return (
    <span
      aria-label="Arkyv"
      className={cn('inline-flex items-baseline font-semibold', className)}
      role="img"
    >
      <span
        className="relative inline-block rotate-180"
        style={{ top: '0.15em', transformOrigin: 'center center' }}
        aria-hidden="true"
      >
        v
      </span>
      <span aria-hidden="true">rkyv</span>
    </span>
  );
}
